import { render, staticRenderFns } from "./PropertyPrice.vue?vue&type=template&id=43063eee&"
import script from "./PropertyPrice.vue?vue&type=script&lang=ts&"
export * from "./PropertyPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports